module.exports = __webpack_public_path__ + "img/ico-expand.4f847a73.svg";